export interface CoordinateRange {
    min: number;
    max: number;
}

export const LATITUDE_RANGE: CoordinateRange = { min: -90, max: 90 };
export const LONGITUDE_RANGE: CoordinateRange = { min: -180, max: 180 };
